import React, { useEffect, useState, useRef } from "react";
import SubmitArrow from "./SubmitArrow";
import Cross from "../../sections/Services/ServicesBreakdown/Cross";
import { graphql, useStaticQuery } from "gatsby";
import useStoryblok from "../../lib/storyblok";

const Popup = (props) => {

    const data = useStaticQuery(graphql`
        query PopupQuery {
            storyblokEntry(full_slug: { eq: "popup" }) {
            id
            content
            }
        }
    `);

    const entry = useStoryblok(data.storyblokEntry);

    const popupTime = parseInt(entry.content?.show_in_x_seconds || 5)


    const [showPopup, setShowPopup] = useState(false)

    const handleEscape = (e) => {
        if (e.key === "Escape") {
            setShowPopup(false)
        }
    }

    useEffect(() => {
        // check if the popup has been shown before
        const popupShown = sessionStorage.getItem("popupShown")

        if (popupShown == undefined && entry.content.enable_popup) {
            // wait 5 seconds after first user interaction
            setTimeout(() => {
                setShowPopup(true)
                sessionStorage.setItem("popupShown", true)
            }
                , popupTime * 1000)
        }

        // listen to escape key

        window.addEventListener("keydown", handleEscape)

    }, [])



    const [hasSubmitted, setHasSubmitted] = useState(false);

    const formRef = useRef(null);

    const handleSubmit = (e) => {
        e.preventDefault()
        let myForm = formRef.current
        let formData = new FormData(myForm);
        fetch("/api/mailchimp", {
            method: "POST",
            body: JSON.stringify(Object.fromEntries(formData)),
        })
            .then(() => console.log("Form successfully submitted"))
            .catch((error) => alert(error));
        setHasSubmitted(true);
        setShowPopup(false);

        if (entry.content?.enable_popup_download){
            window.open(entry.content.popup_download_url.filename, "_blank")
        }

    }


    return (
        <div className={`fixed inset-0 bg-green/40 flex items-center justify-center z-[100] transition-opacity duration-300 ${showPopup ? `opacity-100` : `opacity-0 pointer-events-none`}`} onClick={() => setShowPopup(false)}>

            <div className={`bg-white py-14 px-12  lg:py-24 lg:px-20 space-y-6 relative mobile:max-w-[calc(100%-40px)] transition-all duration-300 delay-150 ${showPopup ? `opacity-100 translate-y-0` : `opacity-0 translate-y-8 pointer-events-none`}`} onClick={(e) => e.stopPropagation()}>
                <h2 className="text-sm lg:text-3xl font-[500]">
                    {entry.content?.cta || "Sign up to our newsletter"}
                </h2>
                <form className="flex border border-green w-full" onSubmit={handleSubmit} ref={formRef} method="post" name="edm">
                    <input type="text" placeholder="Your email" className="appearance-none text-xs lg:text-lg bg-[#F2F2F280] flex-shrink lg:flex-grow h-[3.125rem] border-0 w-full px-4" name="email" type="email" required />
                    <button className="bg-green px-5 ">
                        <SubmitArrow className='w-5 lg:w-8' />
                        <span className="sr-only">Submit</span>
                    </button>
                    <p className="hidden">
                            <label>
                                Don’t fill this out if you’re human: <input name="honey-field" />
                            </label>
                        </p>
                </form>
                {hasSubmitted && (
                        <p className="text-black text-sm lg:text-lg underline font-semibold">
                            Thank you for subscribing!
                        </p>
                    )}

                <button className="absolute right-3 top-3 !my-0" onClick={() => setShowPopup(false)}>
                    <Cross className='rotate-45' />
                    <span className="sr-only">Close</span>
                </button>
            </div>

        </div>
    )
}

export default Popup